/** @jsxImportSource @emotion/react */
import UI from "@mile-meeting/mile-ui";
import { getSlackChannelInfo, TSlackChannel } from "apis/messangers";
import { useEffect, useState } from "react";
import Modal from "react-modal";
import { CancelIcon, ChannelItem, Container, ErrorContainer, Form, Header } from "./AddMeetingSlackModal.styles";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onUpdate?: () => void;
  title: string;
  onHandleAddChannel?: (channelInfo?: TSlackChannel) => void;
  onHandleGuide?: () => void;
};

const AddMeetingSlackModal = (props: Props) => {
  const { modalIsOpen, closeModal, title, onHandleAddChannel, onHandleGuide } = props;
  const [channelInfo, setChannelInfo] = useState<TSlackChannel>();
  const [isError, setIsError] = useState<boolean>(false);
  const [link, setLink] = useState("");
  const [selectedChannel, setSelectedChannel] = useState<boolean>(false);

  const onHandleAdd = async () => {
    if (selectedChannel === false) return;
    onHandleAddChannel?.(channelInfo);
  };

  //* 슬랙 채널 정보 조회
  const setSlackChannelInfo = async () => {
    if (link === "") return;
    const res = await getSlackChannelInfo(link);
    if (res.success) {
      setChannelInfo(res.data);
      setIsError(false);
      setSelectedChannel(true);
      setLink("");
    } else {
      setIsError(true);
      setLink("");
    }
  };

  useEffect(() => {
    if (modalIsOpen) {
      setLink("");
      setChannelInfo(undefined);
      setIsError(false);
      setSelectedChannel(false);
    }
  }, [modalIsOpen]);

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelIcon>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelIcon>
        <Header>
          <div className="title">
            <UI.Typography type="title03" fontStyle="bold" color="var(--alias-color-label-normal)">
              {title}
            </UI.Typography>
          </div>
          <div className="guide">
            <UI.ButtonGroups.Text title="슬랙 채널 추가 가이드" size="small" onClick={onHandleGuide} />
          </div>
        </Header>
        <Form>
          <div className="search">
            <UI.Input placeholder="채널 링크 입력" prefixIcon="link" width={432} showPrefixIcon onChange={setLink} />
            <UI.Button title="조회" disabled={!link} primary={false} size="large" onClick={setSlackChannelInfo} />
          </div>
        </Form>
        {!isError && channelInfo && (
          <ChannelItem onClick={() => setSelectedChannel(!selectedChannel)}>
            <UI.CheckBox selected={selectedChannel} />
            <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
              {channelInfo.slackChannelName}
            </UI.Typography>
          </ChannelItem>
        )}
        {isError && (
          <ErrorContainer>
            <UI.Icon name="info" color="var(--alias-color-status-negative)" size={24} />
            <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
              존재하지 않는 채널입니다. 링크를 재확인해주세요.
            </UI.Typography>
          </ErrorContainer>
        )}
        <UI.Button
          title="추가하기"
          onClick={onHandleAdd}
          disabled={!selectedChannel}
          size="large"
          style={{
            width: "100%",
          }}
        />
      </Container>
    </Modal>
  );
};

export default AddMeetingSlackModal;
